<template>
  <div
    class="modal"
    tabindex="-1"
    :id="id"
    data-backdrop="static"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content bg-ice">
        <div class="modal-header bg-cosmos p-3">
          <span>{{ headerText }}</span>
        </div>
        <div class="modal-body">
          <div
            class="row"
            v-if="text"
          >
            <div class="col-12">
              <p>{{ text }}</p>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <span class="input-group-text">
                    <font-awesome-icon
                      icon="fa-duotone fa-user"
                      aria-hidden="true"
                    />
                  </span>
                </div>
                <input
                  type="text"
                  name="username"
                  class="form-control"
                  :placeholder="usernameText"
                  autofocus
                  autocapitalize="off"
                  spellcheck="false"
                  autocorrect="off"
                  v-model="username"
                  @keyup.enter="login"
                />
              </div>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">
                    <font-awesome-icon
                      icon="fa-duotone fa-key"
                      aria-hidden="true"
                    />
                  </span>
                </div>
                <input
                  type="password"
                  name="password"
                  class="form-control"
                  :placeholder="passwordText"
                  autocomplete="off"
                  autocapitalize="off"
                  spellcheck="false"
                  autocorrect="off"
                  v-model="password"
                  @keyup.enter="login"
                />
              </div>
              <p
                v-if="fehler"
                class="mt-3 mb-0"
                style="color: red"
              >
                {{ errorText }}
              </p>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <div class="row w-100">
            <div class="col-12 text-center">
              <button
                type="button"
                class="btn btn-primary"
                :disabled="!username || !password || loading"
                @click="login"
              >
                <span class="font-khand font-weight-bold">{{ loginText }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'

  import { modal } from '@/mixins/Modal'
  import server from '@/server'

  export default {
    name: 'LoginModal',
    mixins: [modal],
    props: {
      id: {
        type: String,
        default: 'login-modal',
      },
      headerText: {
        type: String,
        default: 'Login',
      },
      text: {
        type: String,
        default: '',
      },
      usernameText: {
        type: String,
        default: 'Benutzername',
      },
      passwordText: {
        type: String,
        default: 'Passwort',
      },
      loginText: {
        type: String,
        default: 'Login',
      },
      errorText: {
        type: String,
        default: 'Login fehlgeschlagen',
      },
    },
    data() {
      return {
        username: null,
        password: null,
        fehler: false,
        loading: false,
      }
    },
    computed: {
      loginUrl() {
        if (process.env.NODE_ENV === 'development') {
          return `${server.url}/login/`
        } else {
          return '/login/'
        }
      },
    },
    methods: {
      // Das Modal darf nur über einen erfolgreichen Login geschlossen werden,
      // sonst bleibt eine leere Seite ohne Möglichkeit zum erneuten Anmelden zurück.
      openModal(id) {
        this.shown = true
        $('#' + (id ? id : this.id)).modal({
          backdrop: 'static',
          keyboard: false,
        })
      },
      handleEscClose() {},
      async login() {
        const params = new URLSearchParams()
        params.append('username', this.username)
        params.append('password', this.password)

        this.loading = true
        try {
          await axios.post(this.loginUrl, params)
          this.fehler = false
          this.password = null
          this.closeModal()
          this.$emit('login')
        } catch (error) {
          this.fehler = true
        } finally {
          this.loading = false
        }
      },
    },
  }
</script>
